import { useEffect, useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();

  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-20 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-2">分类未找到</h2>
            <Link to="/" className="text-sm text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-20 pb-14">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />
          </div>

          <div className="mb-10">
            <h1 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-3">
              {category.name}
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
              {category.description}
            </p>
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                <i className="ri-inbox-line text-2xl"></i>
              </div>
              <p className="text-foreground-600">该分类暂无文章</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}